module.exports = __webpack_public_path__ + "static/firsttime-3e517a9815aaf80a3fd78799b240d365.png";